import { field, asString, parseEnrichedData } from '../utils/enriched-data';

/**
 * Extracts the full-resolution image URL from an item.
 * For TMDB images: uses 'original' size instead of 'w300'
 * For uploaded images: returns as-is
 */
export default function fullResolutionUrl(item: unknown): string {
  // Direct thumbnailUrl field (usually already full-res)
  const thumb = field(item, 'thumbnailUrl');
  if (typeof thumb === 'string' && thumb) {
    return thumb;
  }

  const data = parseEnrichedData(field(item, 'enrichedData'));

  if (data) {
    // TMDB images - use original size
    const imgPath = (data.posterPath ?? data.profilePath) as string | undefined;
    if (typeof imgPath === 'string' && imgPath) {
      // Already full URL
      if (imgPath.startsWith('http')) {
        return imgPath;
      }
      // TMDB path - use original size
      return `https://image.tmdb.org/t/p/original${imgPath}`;
    }

    // Product/service images
    const artworkUrl = asString(data.artworkUrl);
    if (artworkUrl) return artworkUrl;
    const coverUrl = asString(data.coverUrl);
    if (coverUrl) return coverUrl;
    const photoUrl = asString(data.photoUrl);
    if (photoUrl) return photoUrl;

    // Background/fallback images
    const backgroundImage = asString(data.backgroundImage);
    if (backgroundImage) return backgroundImage;
    const imageUrl = asString(data.imageUrl);
    if (imageUrl) return imageUrl;
  }

  // Fallback to empty string
  return '';
}
